export default __webpack_public_path__ + "static/media/Offset-Accumulator.3a5b958d.jpg";